import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(6),
  },
  appBar: {
    padding: 0,
    borderBottom: `1px solid ${theme.palette.secondary.tint15}`,
    backgroundColor: "inherit",
  },
  tabContainer: {
    padding: theme.spacing(10),
    width: "100%",
  },
  titleContainer: {
    backgroundColor: theme.palette.gray2.main,
    padding: theme.spacing(3, 6),
    height: theme.spacing(12),
  },
  titleContainerHeader: {
    backgroundColor: theme.palette.gray2.main,
    padding: theme.spacing(5),
  },
  currencyText: {
    display: "flex",
    alignItems: "center",
  },
  currencyUnit: {
    margin: theme.spacing(0, 2),
  },
  margin: {
    margin: theme.spacing(0, 2),
  },
  currencyItems: {
    maxHeight: theme.spacing(90),
    marginBottom: theme.spacing(3),
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: 0,
    },
    "& .MuiListItem-root": {
      "&:hover": {
        backgroundColor: theme.palette.gray2.main,
        borderRadius: "4px",
      },
    },
    "& .Mui-selected": {
      border: "none",
    },
  },
  currencyItem: {
    height: theme.spacing(20),
    borderBottom: `1px solid ${theme.palette.gray1.main}`,
  },
  currencyImage: {
    height: theme.spacing(18),
    width: theme.spacing(18),
  },
  selectedCurreny: {
    border: `1.5px solid ${theme.palette.primary.main}`,
    borderRadius: "50%",
    padding: theme.spacing(1),
  },
  currencyPrice: {
    display: "flex",
    alignItems: "center",
  },
  ListItemTextPrice: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ListItemTextIcon: {
    marginLeft: theme.spacing(2),
  },
  iconChevronLeft: {
    fontSize: theme.spacing(6),
  },
  icon: {
    margin: theme.spacing(0, 1),
  },
  emptyState: {
    padding: theme.spacing(4, 6),
    textAlign: "center",
  },
}));
